<template>
<div class="product-sales">
<!--  <div class="title-top">产品属性:</div>-->
  <div class="sales-button">
    <div class="sales-button-item"
         :class="p_5 === 1 ? 'active' : ''"
         @click="changeActive(1)">
      <div>
        <p class="title">{{$t('components_basic_addproduct_sales_2130')}}</p>
        <p class="text">{{$t('components_basic_addproduct_sales_2131')}}</p>
      </div>
    </div>
    <div class="sales-button-item"
         :class="p_5 === 2 ? 'active' : ''"
         @click="changeActive(2)">
      <div>
        <p class="title">{{$t('components_basic_addproduct_sales_2132')}}</p>
        <p class="text">{{$t('components_basic_addproduct_sales_2133')}}</p>
      </div>
    </div>
  </div>
  <div class="sales-body">
    <div v-if="p_5 === 1" class="sales-body-one">
      <el-form key="one" ref="optFormOne" :model="optFormOne" :rules="rulesOne">
        <el-row class="form-row">
          <el-col>
            <el-form-item :label="$t('components_basic_addproduct_sales_2134')" prop="price_market">
              <el-input-number
                @change="changeConfirmDisabled"
                :controls="false"
                v-model="optFormOne.price_market"
                :min="0.01"
                :max="999999"
                :precision="2">
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item :label="$t('components_basic_addproduct_sales_2135')" prop="price_sell">
              <el-input-number
                @change="changeConfirmDisabled"
                :controls="false"
                v-model="optFormOne.price_sell"
                :max="999999"
                :min="0.01"
                :precision="2">
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="SKU" prop="sku">
              <el-input-number
                @change="changeConfirmDisabled"
                v-model="optFormOne.sku"
                step-strictly
                :max="999999"
                :step="1"
                :controls="false"
                :min="1">
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item :label="$t('components_basic_addproduct_sales_2136')" prop="weight">
              <el-input-number
                @change="changeConfirmDisabled"
                :controls="false"
                :max="999999"
                v-model="optFormOne.weight"
                :min="0.01"
                :precision="2">
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item :label="$t('components_basic_addproduct_sales_2137')" prop="store">
              <el-input-number
                @change="changeConfirmDisabled"
                v-model="optFormOne.store"
                step-strictly
                :step="1"
                :max="999999"
                :controls="false"
                :min="0">
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="p_5 === 2">
      <div v-if="salesBodyAngShow || (optFormAng.salesAngAttribute && optFormAng.salesAngAttribute.length > 0)" class="sales-body-ang">
        <div class="sales-body-ang-top">
          <div class="body-ang-top-item" v-for="(opt,index) in optFormAng.salesAngAttribute" :key="index">
            <div class="tag-title">{{opt.tagTitle}}:</div>
            <div class="tag-body">
              <div class="body-left">
                <el-tag
                  :class="opt.type === 2 ? 'color-tag-padding' : ''"
                  :key="tag_index"
                  v-for="(tag,tag_index) in opt.tagDataArr"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(index,tag_index)">
                  <div class="color-tag" v-if="opt.type === 2">
                    <el-color-picker
                      :popper-class="`sales-color`"
                      @change="changeColor($event,index,tag_index)"
                      :ref="'colorPicker'+index"
                      v-model="tag.value">
                    </el-color-picker>
                  </div>
                  {{tag.name}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="opt.inputVisible"
                  v-model="inputValue"
                  :ref="'saveTagInput'+index"
                  size="small"
                  @keyup.enter.native="handleInputConfirm(index,opt.type)"
                  @blur.native.capture="handleInputConfirm(index,opt.type)"
                >
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput(index)">+</el-button>
              </div>
              <div class="body-right">
                <div class="body-right-item">
                  <el-button class="right-btn"
                             :disabled="index === 0"
                             @click="moveUp(index)"
                             type="text">{{$t('components_basic_addproduct_sales_2138')}}</el-button>
                  <el-button class="right-btn"
                             :disabled="index+1 === optFormAng.salesAngAttribute.length"
                             @click="moveDown(index)"
                             type="text">{{$t('components_basic_addproduct_sales_2139')}}</el-button>
                  <el-button class="right-btn"
                             @click="editItem(opt,index)"
                             type="text">{{$t('components_basic_addarticle_index_2003')}}</el-button>
                  <el-button class="right-btn"
                             @click="deleteItem(index)"
                             type="text">{{$t('view_god_set_index_226')}}</el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-btn">
            <el-button @click="addItem" type="primary" plain>{{$t('components_basic_addproduct_sales_2140')}}</el-button>
          </div>
        </div>
        <div class="sales-body-ang-bottom">
          <el-form key="ang" ref="optFormAng" :model="optFormAng" :rules="rulesAng">
            <el-table
              class="sales-body-ang-table"
              key="ang"
              ref="multipleTableAng"
              :data="optFormAng.salesAngTable"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChangeAng">
<!--              <el-table-column type="selection" width="56"></el-table-column>-->
              <el-table-column prop="specs" :label="$t('components_basic_addproduct_sales_2141')" fixed width="150" show-overflow-tooltip></el-table-column>
<!--              <el-table-column prop="img" label="配图" min-width="130">-->
<!--                <template slot-scope="scope">-->
<!--                  <div @click="showpop(scope.$index)">-->
<!--                    <div class="add-img" v-if="scope.row.img === ''">-->
<!--                      <i class="el-icon-plus"></i>-->
<!--                    </div>-->
<!--                    <img v-else :src="scope.row.img" alt="" width="32px" height="32px">-->
<!--                  </div>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <el-table-column prop="price_market" :label="$t('components_basic_addproduct_sales_2134')" min-width="130">
                <template slot-scope="scope">
                  <el-form-item :prop="'salesAngTable.' + scope.$index +'.price_market'" :rules='rulesAng.price_market'>
                    <el-input-number
                      @change="changeConfirmDisabled"
                      :controls="false"
                      v-model="scope.row.price_market"
                      :max="999999"
                      :min="0.01"
                      :precision="2">
                    </el-input-number>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="price_sell" :label="$t('components_basic_addproduct_sales_2135')" min-width="130">
                <template slot-scope="scope">
                  <el-form-item :prop="'salesAngTable.' + scope.$index +'.price_sell'" :rules='rulesAng.price_sell'>
                    <el-input-number
                      @change="changeConfirmDisabled"
                      :controls="false"
                      v-model="scope.row.price_sell"
                      :max="999999"
                      :min="0.01"
                      :precision="2">
                    </el-input-number>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="sku" label="SKU" min-width="130">
                <template slot-scope="scope">
                  <el-form-item :prop="'salesAngTable.' + scope.$index +'.sku'" :rules='rulesAng.sku'>
                    <el-input-number
                      @change="changeConfirmDisabled"
                      v-model="scope.row.sku"
                      step-strictly
                      :step="1"
                      :controls="false"
                      :max="999999"
                      :min="1"
                    >
                    </el-input-number>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="weight" :label="$t('components_basic_addproduct_sales_2136')" min-width="130">
                <template slot-scope="scope">
                  <el-form-item :prop="'salesAngTable.' + scope.$index +'.weight'" :rules='rulesAng.weight'>
                    <el-input-number
                      @change="changeConfirmDisabled"
                      :controls="false"
                      v-model="scope.row.weight"
                      :max="999999"
                      :min="0.01"
                      :precision="2">
                    </el-input-number>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="store" :label="$t('components_basic_addproduct_sales_2137')" fixed="right" min-width="130">
                <template slot-scope="scope">
                  <el-form-item :prop="'salesAngTable.' + scope.$index +'.store'" :rules='rulesAng.store'>
                    <el-input-number
                      @change="changeConfirmDisabled"
                      v-model="scope.row.store"
                      step-strictly
                      :step="1"
                      :controls="false"
                      :max="999999"
                      :min="0"
                    >
                    </el-input-number>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </div>
      <div class="empty-body-ang" v-else>
        <p class="empty_img">
          <i class="jz_empty_tips__img"></i>
        </p>
        <p style="font-size: 14px">{{$t('components_basic_addproduct_sales_2142')}}</p>
        <el-button class="empty-btn" @click="salesBodyAngShow = true" type="primary">{{$t('components_basic_addarticle_index_2004')}}</el-button>
      </div>
    </div>
  </div>
  <el-dialog key="sales"
             custom-class="dialog-form"
             :title="$t('components_basic_addproduct_sales_2140')"
             append-to-body
             @closed="closeDialogForm"
             :close-on-click-modal="false"
             width="460px"
             v-if="dialogFormVisible"
             :visible.sync="dialogFormVisible">
    <el-form @submit.native.prevent ref="dialogForm" :model="dialogForm" label-width="95px" :rules="dialogFormRules">
      <el-form-item :label="$t('view_form_dialog_add_form_item_187')" prop="type">
        <el-radio-group style="height: 48px; width: 280px;line-height: 48px" v-model="dialogForm.type" @change="changeType">
          <el-radio :label="1">{{$t('base_module_config_1659')}}</el-radio>
          <el-radio :label="2">{{$t('base_colorschemedesigner_629')}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('components_basic_addproduct_sales_2143')" prop="tagTitle">
        <el-input
          :maxlength="30"
          show-word-limit
          style="width: 280px;"
          v-model="dialogForm.tagTitle"
          autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialogForm">{{$t('view_public_topbar_14')}}</el-button>
      <el-button type="primary" @click="addSpecs">{{$t('view_public_topbar_15')}}</el-button>
    </div>
  </el-dialog>
  <ydyl-file-center
    :locale="ydylLang"
    :visible.sync="popshow"
    :configs="ydyl_file_configs"
    :options="ydyl_file_options"
    @change="onChange"
  />
</div>
</template>

<script>
import i18n from '../../language/index'

import {deepClone} from "../../utils/utils";
import {chineseRule,checkChineseRule} from "../../base/valid";
import { getYdylFileLang } from '@/base/cookie'

export default {
  name: "sales",
  data(){
    var chineseRuleValidator = (rule, value, callback) => {
      chineseRule(rule, value, callback,15)
    };
    return {
      ydylLang: getYdylFileLang(),
      salesBodyAngShow:false,
      imgIndex:-1,
      popshow:false,
      ydyl_file_configs: {
        baseURL:process.env.VUE_APP_YYP,//api请求地址
        folderModule: 1,//  模块id, 1 海外建站 2 邮件营销 3 投放中心 4 社媒营销 5 品牌建设 6 客户管理 7 其他
      },
      ydyl_file_options:{
        limit: 15,             // 接受的文件数量， 默认 1， 0表示不限制 （前端）
        fileFormats: ["jpeg","jpg","png","webp"], // 格式：JPG、JPEG、PNG MP4、MOV,  数组
        // maxFileSize: 0,       // 文件最大限制Kb
      },
      nowIndex:'',
      dialogFormVisible: false,
      dialogForm:{
        tagTitle:'',
        type:1,
        tagDataArr:[],
        inputVisible:false
      },
      dialogFormRules: {
        tagTitle: [
          { required: true, message: i18n.t('components_basic_addproduct_sales_2144'), trigger: 'blur' },
          {
            validator: chineseRuleValidator,
            trigger: "blur"
          },
          {pattern: '[^ \x22]+', message: i18n.t('components_basic_addproduct_sales_2145')}
        ],
      },
      inputVisible:false,
      inputValue:'',
      p_5:1,
      optFormOne:{},
      optFormAng:{},
      rulesOne:{
        price_market: [{ required: true, message: i18n.t('components_basic_addproduct_sales_2146'), trigger: 'blur'}],
        price_sell: [{ required: true, message: i18n.t('components_basic_addproduct_sales_2146'), trigger: 'blur'}],
        sku: [{ required: true, message: i18n.t('components_basic_addproduct_sales_2146'), trigger: 'blur'}],
        weight: [{ required: true, message: i18n.t('components_basic_addproduct_sales_2146'), trigger: 'blur'}],
        store: [{ required: true, message: i18n.t('components_basic_addproduct_sales_2146'), trigger: 'blur'}],
      },
      rulesAng:{
        price_market: [{ required: true, message: i18n.t('components_basic_addproduct_sales_2146'), trigger: 'blur'}],
        price_sell: [{ required: true, message: i18n.t('components_basic_addproduct_sales_2146'), trigger: 'blur'}],
        sku: [{ required: true, message: i18n.t('components_basic_addproduct_sales_2146'), trigger: 'blur'}],
        weight: [{ required: true, message: i18n.t('components_basic_addproduct_sales_2146'), trigger: 'blur'}],
        store: [{ required: true, message: i18n.t('components_basic_addproduct_sales_2146'), trigger: 'blur'}],
      },
      cloneDataSalesAngTable:{},
      isChangeType: false,
      changeTypeInfo: 1
    }
  },
  created() {
    // this.makeSalesAngTable()
  },
  methods:{
    changeConfirmDisabled(){
        this.$emit('changeConfirmDisabled',false)
    },
    init(optFormOne,optFormAng,p_5){
      this.optFormOne = optFormOne
      this.optFormAng = optFormAng
      if (this.optFormAng.salesAngTable.length > 0){
        this.optFormAng.salesAngTable.forEach((res,index) => {
          res.specs = res.specs.join('/')
        })
      }
      this.p_5 = p_5
      this.cloneDataSalesAngTable = deepClone(this.optFormAng.salesAngTable)
    },
    checkNum(){
      let list = [];
      if (this.optFormAng.salesAngAttribute.length > 0){
        this.optFormAng.salesAngAttribute.map((res,index) => {
          if (res.tagDataArr.length > 0){
            let listItem = []
            res.tagDataArr.forEach((item,index) => {
              listItem.push(item.name)
            })
            list.push(listItem)
          }
        })
        if (list.length > 0){
          const tabListNumInfo = this.getSkuInfo(list)
          return  tabListNumInfo.length;
        }else {
          return 0;
        }
      }
    },
    //组装sku数据
    makeSalesAngTable(){
      let list = [];
      let listIndex = [];
      if (this.optFormAng.salesAngAttribute.length > 0){
        this.optFormAng.salesAngAttribute.map((res,index) => {
          if (res.tagDataArr.length > 0){
            let listItem = []
            let listItemIndex = []
            res.tagDataArr.forEach((item,index) => {
              listItem.push(item.name)
              listItemIndex.push(index)
            })
            list.push(listItem)
            listIndex.push(listItemIndex)
          }
        })
      }
      if (list.length > 0 && listIndex.length > 0){
        const tabListInfo = this.getSkuInfo(list)
        const tabListInfoIndex = this.getSkuInfo(listIndex)
        const tableList = [];
        if (tabListInfo.length > 0){
          tabListInfo.forEach((item,index) => {
            if (index <= 100){
              tableList.push({
                specs:item.join('/'),
                spec:tabListInfoIndex[index].join('/'),
                img:'',
                price_market:undefined,
                price_sell:undefined,
                sku:undefined,
                weight:undefined,
                store:undefined,
              })
            }
          })
        }
        //新数据 newList
        if (this.cloneDataSalesAngTable.length > 0){
          this.cloneDataSalesAngTable.map(cl => {
            tableList.map((item,index) => {
              if (cl.spec === item.spec){
                // item.specs = cl.specs;
                // item.spec = cl.spec;
                item.img = cl.img;
                item.price_market = cl.price_market;
                item.price_sell = cl.price_sell;
                item.sku = cl.sku;
                item.weight = cl.weight;
                item.store = cl.store;
              }
            })

          })
        }
        this.optFormAng.salesAngTable = tableList
        this.cloneDataSalesAngTable = deepClone(this.optFormAng.salesAngTable)
      }else {
        this.optFormAng.salesAngTable = [];
        this.cloneDataSalesAngTable = deepClone(this.optFormAng.salesAngTable)
      }
    },
    //组装列表数据
    getSkuInfo(list){
      function sortTable(arr, item) {
        let brr = [];
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < item.length; j++) {
            if (typeof arr[i] == 'object') {
              brr.push([...arr[i],item[j]])
            }else{
              brr.push([arr[i],item[j]])
            }
          }
        }
        return brr;
      }
      if (list.length>1) {
        return list.reduce(sortTable)
      }else{
        let arr = []
        list[0].forEach(item=>{
          arr.push([item])
        })
        return arr
      }
    },
    //颜色发生改变触发
    changeColor(e,index,tag_index){
      this.optFormAng.salesAngAttribute[index].tagDataArr[tag_index].value = e;
      this.changeConfirmDisabled()
    },
    //打开选色器
    openColor(index){
      if (this.$refs['colorPicker'+index]){
        const colorPickerLen = this.$refs['colorPicker'+index].length
        setTimeout(() => {
          this.$refs['colorPicker'+index][colorPickerLen-1].showPicker =  true
        }, 300);
      }
    },
    //切换tab
    changeActive(tab){
      this.p_5 = tab
      this.$emit('getSalesType',this.p_5)
    },
    handleSelectionChangeOne(){

    },
    handleSelectionChangeAng(){

    },
    handleClose(index,tag_index) {
      this.optFormAng.salesAngAttribute[index].tagDataArr.splice(tag_index, 1);
      this.makeSalesAngTable()
      this.changeConfirmDisabled()
    },
    //展示输入框
    showInput(index) {
      if (this.optFormAng.salesAngAttribute.length > 0){
        this.optFormAng.salesAngAttribute.map(item => {
          item.inputVisible = false
        })
      }
      this.$set(this.optFormAng.salesAngAttribute[index],'inputVisible',true)
      this.$nextTick(_ => {
        this.$refs['saveTagInput'+index][0].focus();
      });
    },
    //添加规格属性
    handleInputConfirm(index,type) {
      if (this.optFormAng.salesAngAttribute[index].tagDataArr.length >= 10){
        this.closeChange(i18n.t('components_basic_addproduct_sales_2147'))
        this.optFormAng.salesAngAttribute[index].inputVisible = false;
        this.inputValue = '';
      }
      let inputValue = this.inputValue.replace(/\s/g,"");
      if (inputValue === '' && this.inputValue.length > 0){
        this.closeChange(i18n.t('components_basic_addproduct_sales_2148'))
        this.optFormAng.salesAngAttribute[index].inputVisible = false;
        this.inputValue = '';
        return this.$message.warning(i18n.t('components_basic_addproduct_sales_2148'))
      }
      let msgError = checkChineseRule(inputValue);
      if (msgError !== ''){
        this.closeChange(msgError)
        this.optFormAng.salesAngAttribute[index].inputVisible = false;
        this.inputValue = '';
        return this.$message.warning(msgError)
      }
      if (inputValue.length > 30){
        this.closeChange(i18n.t('components_basic_addproduct_sales_2149'))
        this.optFormAng.salesAngAttribute[index].inputVisible = false;
        this.inputValue = '';
        return this.$message.warning(i18n.t('components_basic_addproduct_sales_2149'))
      }
      if (this.optFormAng.salesAngAttribute[index].tagDataArr !== undefined && this.optFormAng.salesAngAttribute[index].tagDataArr.length > 0){
        const repeat = this.optFormAng.salesAngAttribute[index].tagDataArr.find(d => d.name === this.inputValue)
        if (repeat){
          this.closeChange(i18n.t('components_basic_addproduct_sales_2150'))
          this.optFormAng.salesAngAttribute[index].inputVisible = false;
          this.inputValue = '';
          return this.$message.warning(i18n.t('components_basic_addproduct_sales_2150'))
        }
      }
      let pushInfo = {}
      if (type === 1){
        pushInfo.name = inputValue
        pushInfo.value = inputValue
      }else {
        pushInfo.name = inputValue
        pushInfo.value = "#FFFFFF"
      }
      if (inputValue) {
        this.optFormAng.salesAngAttribute[index].tagDataArr.push(pushInfo);
      }
      //检测规格数量
      const num = this.checkNum();
      if (num > 100){
        const lengthInfo = this.optFormAng.salesAngAttribute[index].tagDataArr.length
        this.optFormAng.salesAngAttribute[index].tagDataArr.splice(lengthInfo-1, 1);
        this.optFormAng.salesAngAttribute[index].inputVisible = false;
        this.inputValue = '';
        return this.$message.warning(i18n.t('components_basic_addproduct_sales_2151'))
      }
      this.optFormAng.salesAngAttribute[index].inputVisible = false;
      this.closeChange('')
      this.inputValue = '';
      this.$nextTick(_ => {
        if (inputValue && type === 2){
          this.openColor(index);
        }
      });
      this.$nextTick(_ => {
        this.makeSalesAngTable()
      });
      this.changeConfirmDisabled()
    },
    //添加规格项
    addSpecs(){
      let salesAngAttributeItem = this.dialogForm
      this.$refs['dialogForm'].validate((valid, data) => {
        if (valid){
          //新增还是编辑
          if(this.nowIndex !== ''){
            if (this.isChangeType){
              salesAngAttributeItem.tagDataArr = [];
              this.optFormAng.salesAngAttribute[this.nowIndex].tagDataArr = [];
              this.optFormAng.salesAngAttribute[this.nowIndex].type = this.changeTypeInfo;
            }
            this.optFormAng.salesAngAttribute[this.nowIndex] = salesAngAttributeItem
          }else {
            this.optFormAng.salesAngAttribute.push(salesAngAttributeItem)
          }
          this.isChangeType = false;
          this.changeTypeInfo = 1
          this.nowIndex = '';
          this.dialogForm = {
            tagTitle:'',
            type:1,
            tagDataArr:[],
            inputVisible:false
          }
          this.makeSalesAngTable()
          this.dialogFormVisible = false
          this.changeConfirmDisabled()
        }
      })
    },
    //切换类型时触发
    changeType(e){
      if (this.nowIndex !== ''){
        this.isChangeType = true;
        this.changeTypeInfo = e
        // this.optFormAng.salesAngAttribute[this.nowIndex].tagDataArr = [];
        // this.optFormAng.salesAngAttribute[this.nowIndex].type = e;
        // this.changeConfirmDisabled()
      }
    },
    // 上移
    moveUp (index) {
      let arr = this.optFormAng.salesAngAttribute
      arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]))
      this.makeSalesAngTable()
      this.changeConfirmDisabled()
    },
    // 下移
    moveDown (index) {
      let arr = this.optFormAng.salesAngAttribute
      arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]))
      this.makeSalesAngTable()
      this.changeConfirmDisabled()
    },
    // 删除
    deleteItem (index) {
      const msg = i18n.t('view_god_set_index_226')
      const confirmText = i18n.t('components_basic_addproduct_sales_2152')
      this.$confirm(confirmText, msg, {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        type: "warning",
      }).then(async () => {
        this.optFormAng.salesAngAttribute.splice(index, 1)
        this.makeSalesAngTable()
        this.changeConfirmDisabled()
      }).catch(() => {});

    },
    // 编辑
    editItem (opt,index) {
      //记录一下当前类型
      this.nowIndex = index
      this.dialogForm = {...opt}
      this.dialogFormVisible = true
    },
    closeDialogForm(){
      this.nowIndex = ''
      this.dialogForm = {
        tagTitle:'',
        type:1,
        tagDataArr:[],
        inputVisible:false
      }
      this.dialogFormVisible = false
    },
    //添加
    addItem() {
      if (this.optFormAng.salesAngAttribute.length >= 10){
        return this.$message.warning(i18n.t('components_basic_addproduct_sales_2153'))
      }
      this.dialogFormVisible = true
    },
    //关闭弹窗重新加载数据
    closeChange(error){
      //  调用父组件方法
      this.$emit('getSalesInfo',error)
    },
    //上传配图
    showpop(index){
      this.ydyl_file_options.limit = 1;
      this.imgIndex = index
      this.popshow = true;
    },
    //资源库抛出数据
    onChange(data){
      if (data.constructor !== Array){
        data = [data]
      }
      data.map(e => {
        e.path = e.fileUrl;
        e.fileName = e.name;
        e.filePath = e.fileUrl;
      });
      this.getdata(data)
    },
    getdata(data) {
      // 资源库传递出来的图片
      data.map(e => {
        e.path = e.filePath ? e.filePath : e.path;
        return e;
      });
      this.optFormAng.salesAngTable[this.imgIndex].img = data[0].filePath
      this.cloneDataSalesAngTable = deepClone(this.optFormAng.salesAngTable)
      this.changeConfirmDisabled()
    },
  },
}
</script>

<style lang="scss" scoped>
.product-sales{
  font-family: PingFangSC-Medium, PingFang SC !important;
  .title-top{
    height: 47px;
    line-height: 47px;
  }
  .sales-button{
    width: 100%;
    display: flex;
    justify-content: space-between;
    .sales-button-item{
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(50% - 8px);
      height: 100px;
      background: #F2F2F2;
      .title{
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        width: 100%;
        text-align: center;
      }
      .text{
        width: 100%;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        margin-top: 4px;
        text-align: center;
      }
    }
    .active{
      border: 2px solid #1E50AE;
      background: #FFFFFF;
    }
  }
  .sales-body{
    .sales-body-ang-top{
      .footer-btn{
        margin-top: 24px;
        margin-bottom: 24px;
      }
      .body-ang-top-item{
        margin-top: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        .tag-title{
          margin-bottom: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }
        .tag-body{
          display: flex;
          justify-content: space-between;
          .body-left{
           flex: 1;
            height: 100%;
            border: 1px solid #DCDFE6;
            border-radius: 4px;
            padding: 8px 8px 0px;
            /deep/ .el-input--small .el-input__inner{
              margin-bottom: 8px;
            }
          }
          .body-right{
            width: 160px;
            margin-left: 16px;
            .right-btn{
              margin-left: 8px;
            }
            .body-right-item{
              height: 100%;
              display: flex;
            }
          }
        }
        .color-tag{
          position: absolute;
          left: 5px;
          top: 3px;
          height: 24px;
          border-radius: 50%;
        }
        .color-tag-padding{
          position: relative;
          padding-left: 30px;
        }
      }
      /deep/ {
        .el-color-picker{
          height: 24px;
          border-radius: 50%;
        }
        .el-color-picker__color{
          border: none;
          border-radius: 50%;
        }
        .el-color-picker__color-inner{
          border-radius: 50%;
        }
        .el-color-picker__trigger{
          height: 24px;
          width: 24px;
          border: none;
          .el-icon-close,
          .el-icon-arrow-down:before{
            display: none;
          }
        }
        .el-tag{
          margin-right: 10px !important;
          margin-bottom: 8px;
        }
        .button-new-tag {
          height: 32px;
          line-height: 30px;
          padding-top: 0;
          padding-bottom: 0;
          margin-bottom: 8px;
        }
      }
      .input-new-tag{
        width: 90px;
        vertical-align: bottom;
      }
    };
    .sales-body-ang-bottom{
      margin-top: 16px;
    }
    .empty-body-ang{
      width: 770px;
      height: 100%;
      margin: 44px 0;
      text-align: center;
      .empty_img{
        margin-left: 315px;
        margin-bottom: 16px;
        width: 120px;
        height: 120px;
        img{
          height: 120px;
          width: 120px;
        }
      }
      .empty-btn{
        margin-top: 16px;
        width: 120px;
      }
    }
    .sales-body-one{
      margin-top:24px;
      /deep/ label{
        min-width: 130px;
        display: inline-block;
        text-align: left;
        height: 24px;
        line-height: 24px;
      }
    }
    .sales-body-one{
      .form-row{
        display: flex;
        overflow: hidden;
        overflow-x: auto;
        /deep/ .el-col{
          width: 20%;
          margin-right: 8px;
          margin-left: 8px;
        }
      }
      .el-input-number{
        width: 130px;
        padding-left: 0px !important;
        min-width: 100px !important;
        /deep/ .el-input__inner{
          text-align: left !important;
        }
      }

    }
    .sales-body-ang-table{
      .add-img{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 32px;
        height: 32px;
        background: #FFFFFF;
        border: 1px solid #97A5EE;
        color: #97A5EE;
      }
      ::v-deep {
        .el-table__fixed{
          height: calc(100% + 10px) !important;
        }
        .el-table__fixed-right{
          height: calc(100% + 10px) !important;
        }
      }
      /deep/ {
        .el-input__inner {
          width: 120px;
          text-align: left;
        }
        .el-form-item{
          margin-bottom: 16px !important;
        }
        .el-form-item__error{
          padding-top: 2px;
        }
        .el-input-number{
          padding-left: 0px !important;
        }
      }
    }
  }
}
</style>
<style>
.sales-body-ang-table .el-table__fixed{
  height: calc(100% + 10px) !important;
}
.sales-body-ang-table .el-table__fixed-right{
  height: calc(100% + 10px) !important;
}
.sales-color .el-color-dropdown__btns .el-color-dropdown__link-btn{
  display: none;
}
</style>




// WEBPACK FOOTER //
// src/components/basic_addProduct/sales.vue